import React from 'react'
import { withTranslation } from 'react-i18next'

import { IconCheckMark } from 'svg'

import UploadImage from 'components/Form/UploadImage/UploadImage'
import TextInput from 'components/Form/TextInput/TextInput'
import TextArea from 'components/Form/TextArea/TextArea'
import ElementsGroup from 'components/Form/ElementsGroup/ElementsGroup'

import AddListItemButton from '../../../Controls/AddListItemButton'

import { checkAndReturnArrayOfErrors } from '../utilities'

const Question = props => {
    const {
        validationStructure,
        tabsValidationResult: { errors },
        question,
        qIndex,
        methods,
        t,
    } = props

    return (
        <div>
            <h3 className="scroll-item tab-title" data-scroll={qIndex}>
                <span>
                    {t('Question')} {qIndex + 1}
                </span>
                <div className="control">
                    <ul className="actions">
                        {methods.canDo('changePosition', 'questions', {
                            newIndex: qIndex - 1,
                        }) && (
                            <li
                                className="rounded"
                                data-icon="up"
                                title={t('Move up')}
                                onClick={() =>
                                    methods.onChangePosition('questions', {
                                        index: qIndex,
                                        newIndex: qIndex - 1,
                                    })
                                }
                            />
                        )}
                        {methods.canDo('changePosition', 'questions', { newIndex: qIndex + 1 }) && (
                            <li
                                className="rounded"
                                data-icon="down"
                                title={t('Move down')}
                                onClick={() =>
                                    methods.onChangePosition('questions', {
                                        index: qIndex,
                                        newIndex: qIndex + 1,
                                    })
                                }
                            />
                        )}
                        {methods.canDo('add', 'questions') && (
                            <li
                                className="rounded"
                                data-icon="clone"
                                title={t('Clone')}
                                onClick={() =>
                                    methods.onClone('questions', {
                                        index: qIndex,
                                        newIndex: qIndex + 1,
                                    })
                                }
                            />
                        )}
                        {methods.canDo('remove', 'questions') && (
                            <li
                                className="rounded"
                                data-icon="remove"
                                title={t('Remove')}
                                onClick={() => methods.onRemove('questions', { qIndex: qIndex })}
                            />
                        )}
                    </ul>
                </div>
            </h3>
            <div className="content">
                <ul className="q-content">
                    <TextArea
                        isRequired={validationStructure._fields['questions.text'].required}
                        label={t('Question text')}
                        errorMessages={checkAndReturnArrayOfErrors(
                            errors,
                            `questions[${qIndex}].text`,
                            t('This field is required'),
                        )}
                        value={question.text}
                        onUpdate={value => methods.handleChange__tmpStructure(`questions[${qIndex}].text`, value)}
                    />
                    <ElementsGroup>
                        <UploadImage
                            label={t('Question image')}
                            value={question.image}
                            onUpdate={value => methods.onPlaceImage(`questions[${qIndex}].image`, value)}
                        />
                        {question.image && (
                            <TextInput
                                label={t('Image disclaimer')}
                                description={'(optional)'}
                                value={question.imageDisclaimer}
                                onUpdate={value =>
                                    methods.handleChange__tmpStructure(`questions[${qIndex}].imageDisclaimer`, value)
                                }
                            />
                        )}
                    </ElementsGroup>
                    <div className="block--checkbox">
                        <ul>
                            <li
                                className={question.isText ? 'is-active' : ''}
                                onClick={() => methods.handleChange__tmpStructure(`questions[${qIndex}].isText`, true)}
                            >
                                <div className="img" data-image="text" />
                                Text
                            </li>
                            <li
                                className={!question.isText ? 'is-active' : ''}
                                onClick={() => methods.handleChange__tmpStructure(`questions[${qIndex}].isText`, false)}
                            >
                                <div className="img" data-image="images" />
                                {t('Images')}
                            </li>
                        </ul>
                    </div>
                </ul>
                {question.answers.length && (
                    <ul className="a-content">
                        {question.answers.map((a, aIndex) => {
                            return (
                                <li key={a.id} id={`scroll-element-${qIndex}.${aIndex}`}>
                                    <div className="input-block">
                                        <div className="label label--centered">
                                            <span
                                                className="text"
                                                data-required={
                                                    question.isText
                                                        ? validationStructure._fields[
                                                              'questions.answers.text'
                                                          ].required(question)
                                                        : false
                                                }
                                            >
                                                {t('Answer')} {aIndex + 1}
                                            </span>
                                            <ul className="group">
                                                <li>
                                                    <div
                                                        className={`checkbox-block${
                                                            methods.canDo(
                                                                'setAnswerCorrect',
                                                                {},
                                                                {
                                                                    value: !a.isCorrect,
                                                                    qIndex: qIndex,
                                                                },
                                                            )
                                                                ? ''
                                                                : ' is-disabled'
                                                        }`}
                                                        onClick={() =>
                                                            methods.onSetAnswerCorrect(qIndex, aIndex, !a.isCorrect)
                                                        }
                                                    >
                                                        <div
                                                            className={`checkbox-box ${
                                                                a.isCorrect ? 'is-checked' : ''
                                                            }`}
                                                        >
                                                            <IconCheckMark />
                                                        </div>
                                                        <p>{t('Correct answer')}</p>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                        {question.isText ? (
                                            <TextArea
                                                rows={1}
                                                isRequired={validationStructure._fields['questions.text'].required}
                                                errorMessages={checkAndReturnArrayOfErrors(
                                                    errors,
                                                    `questions[${qIndex}].answers[${aIndex}].text`,
                                                    t('This field is required'),
                                                )}
                                                value={a.text}
                                                onUpdate={value =>
                                                    methods.handleChange__tmpStructure(
                                                        `questions[${qIndex}].answers[${aIndex}].text`,
                                                        value,
                                                    )
                                                }
                                            />
                                        ) : (
                                            <ElementsGroup>
                                                <UploadImage
                                                    value={a.image}
                                                    onUpdate={value =>
                                                        methods.onPlaceImage(
                                                            `questions[${qIndex}].answers[${aIndex}].image`,
                                                            value,
                                                        )
                                                    }
                                                    isDisabledDelete
                                                />
                                                <TextInput
                                                    value={a.imageLabel}
                                                    onUpdate={value =>
                                                        methods.handleChange__tmpStructure(
                                                            `questions[${qIndex}].answers[${aIndex}].imageLabel`,
                                                            value,
                                                        )
                                                    }
                                                />
                                            </ElementsGroup>
                                        )}
                                        <ul className="actions">
                                            {methods.canDo('remove', 'questions.answers', {
                                                value: !a.isCorrect,
                                                qIndex: qIndex,
                                            }) && (
                                                <li
                                                    data-icon="remove"
                                                    title={t('Remove')}
                                                    onClick={() =>
                                                        methods.onRemove('questions.answers', {
                                                            value: !a.isCorrect,
                                                            qIndex: qIndex,
                                                            aIndex,
                                                        })
                                                    }
                                                />
                                            )}
                                        </ul>
                                    </div>
                                    {question.isText ? (
                                        <TextArea
                                            label={t('Description')}
                                            rows={1}
                                            value={a.description}
                                            onUpdate={value =>
                                                methods.handleChange__tmpStructure(
                                                    `questions[${qIndex}].answers[${aIndex}].description`,
                                                    value,
                                                )
                                            }
                                        />
                                    ) : (
                                        <TextArea
                                            label={t('Description')}
                                            rows={1}
                                            value={a.imageDescription}
                                            onUpdate={value =>
                                                methods.handleChange__tmpStructure(
                                                    `questions[${qIndex}].answers[${aIndex}].imageDescription`,
                                                    value,
                                                )
                                            }
                                        />
                                    )}
                                </li>
                            )
                        })}
                    </ul>
                )}
                {methods.canDo('add', 'questions.answers', { qIndex: qIndex }) && (
                    <AddListItemButton
                        title={t('Add answer')}
                        length={question.answers.length}
                        onClick={() => methods.onAdd('questions.answers', { qIndex: qIndex })}
                    />
                )}
            </div>
        </div>
    )
}

export default withTranslation('translations')(Question)
